import { DetailedHTMLProps, InputHTMLAttributes } from 'react'
import { cs } from '../../utils'
import styles from './Input.module.scss'

type InputProps = { error?: boolean; innerLabel?: boolean } & DetailedHTMLProps<
  InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
>

export function Input({
  type = 'text',
  className,
  children,
  error,
  innerLabel,
  ...props
}: InputProps) {
  return (
    <div className={cs(styles.inputContainer, error && styles.error)}>
      <label className={cs(styles.label, innerLabel && styles.inner)}>
        {children}
      </label>
      <input
        className={cs(styles.input, className, innerLabel && styles.innerLabel)}
        {...props}
      />
    </div>
  )
}
